export default {
    BASE_URL: '/member/disregister',
    api: [
        {
            name: 'list',
            desc: '审核列表',
            method: 'GET',
            path: '/list'
        },
        {
            name: 'audit',
            desc: '账号注销审核',
            method: 'POST',
            path: '/audit'
        },
    ]
}


// WEBPACK FOOTER //
// ./src/api/apis/member/member-quit.js